import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges, Inject, OnDestroy, TemplateRef, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { DOCUMENT, DatePipe } from '@angular/common';
import colorsJsonGreen from './../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from './../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from './../../../../assets/teiasoft-themes/silver.json';
import { TranslateService } from '@ngx-translate/core';
import { TeiasoftOdataService } from '../../services/teiasoft-bucket/teiasoft-odata.service';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftGridService } from '../../services/teiasoft-bucket/teiasoft-grid.service';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';
import { SelectOption } from '../teiasoft-select/teiasoft-select.component';
import { Globals } from '../../globals/globals';
import { ClickedCell } from '../teiasoft-grid/teiasoft-grid.component';
import { Subscription } from 'rxjs';
import { UtilsService } from '../../services/utils/utils.service';
import { BackendService } from '../../services/backend/backend.service';
import { HeaderParametersValues, UomsType } from '../../models/data/headerParametersValues.model';
import { RoundDigit } from '../../models/data/roundDigit.model';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';
import { getDateOnlyDisplayDate } from '../../utils/date-only.utils';

declare var $: any; // ToREMOVE - Gestiamo gli oggetti html con puro javascript

export class ColumnWidth {
  colName?: string;
  length?: number;
  width?: number;
}

export class CellSpecialStyle {
  colName?: string;
  bgColorSourceData?: string;
}

export class GridSorting {
  column?: string;
  direction?: string;
}

export class GridConfiguration {
  name?: string;
  gridColumns?: GridColumn[];
  gridSortings?: GridSorting[];
  defaultFilterView?: string;
  frozenColumns: number = 0;
  activeFrozenColumns: number = 0;
  options: any;
}

export class GridColumn {
  id?: number;
  name?: string;
  type?: string;
  visible?: boolean;
  exclude?: boolean;
  width?: number;
  position?: number;
}

export class GridFilter {
  column?: string;
  filterType?: string;
  visible?: boolean;
  filterVisible?: boolean | null;
  optionsList?: SelectOption[];
  initialValue?: any
}

export class ActiveFilter {
  columun?: string;
  value?: any;
  dateDirection?: string;
  operator?: string;
  isDefaultView?: boolean;
}

export class MenuVoice {
  text?: string;
  action?: string;
  icon?: string;
}

export class CustomIcoCol {
  tooltip?: string;
  icon?: string[];
  color?: string;
  action?: string;
  position?: string;
  isMenu?: boolean;
  menuVoices?: MenuVoice[];
  disabled?: boolean | ((row: any) => boolean);
  getIcon?: (row: any) => string[];
  getColor?: (row: any) => string | null | undefined;
  getTooltip?: (row: any) => string;
}

export class CalculatedCols {
  id?: number;
  icon?: string;
  tooltip?: string;
  method?: string;
  position?: string;
  header?: string;
}

export class ODataGridFilterMap {
  columnName?: string;
  filterName?: string;
}

export class ODataGridFilter {
  grid?: string;
  filters?: ODataGridFilterMap[];
}

export interface OdataGridInitialFilters {
  column: string;
  type: 'string' | 'number' | 'date' | 'select' | 'any[]';
  op?: string; // e.g. 'eq' | 'gt' | 'lt' | 'between' | 'contains'...
  value?: any; // single value or from-value (for ranges)
  valueTo?: any; // to-value for ranges
  uom?: string; // for numeric + uom filters
}

@Component({
  selector: 'teiasoft-grid-odata',
  templateUrl: './teiasoft-grid-odata.component.html',
  styleUrls: ['./teiasoft-grid-odata.component.scss']
})

export class TeiasoftGridOdataComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() columnsGOD: GridColumn[] = new Array();
  //@Input() columnsToShow: string[] = new Array(); // In Griglia OData la columnsToShow non è utilizzata
  @Input() columnsToShowRow: string[] = new Array(); // Usata per la griglia normale mosytrata nela riga della griglia odata
  @Input() columnsToHideGOD: string[] = new Array();
  @Input() cellSpecialStyles: CellSpecialStyle[] = new Array();
  @Input() dataSet: any[] = new Array();
  @Input() showFooter: boolean = true;
  @Input() selectable: boolean = false;
  @Input() multiSelection: boolean = false;
  @Input() paginable: boolean = false;
  @Input() rowsPerPage: number = 5;
  @Input() theme: string = "silver"; // DEFAULT THEME
  @Input() filterable: boolean = false;
  @Input() sortable: boolean = true;
  @Input() showEditIcon: boolean = false;
  @Input() showDeleteIcon: boolean = false;
  @Input() translateRoot: string = 'grid';
  @Input() autoWidth: boolean = false;
  @Input() customIcoCols: CustomIcoCol[] = new Array();
  @Input() calculatedCols: CalculatedCols[] = new Array();
  @Input() disableAllSelection: boolean = false;
  @Input() clearFilters: boolean = false;
  @Input() type: string = "date";
  @Input() dateFormat: string = "";
  @Input() dateTimeFormat: string = "";
  @Input() dateOnlyColumns: string[] = ['duedate', 'offervaliditydate', 'customerRequestDate',
    'offerSentToCustomerDate', 'bookedOrderDate'];
  @Input() showSettingsDialog: boolean = false;
  @Input() gridConfiguration: GridConfiguration = new GridConfiguration();
  // @Input() refreshGrid: boolean = false;
  @Input() refreshGridKey: Number = 0;

  @Input() columnsWidth: ColumnWidth[] = new Array();
  @Input() odataEntity: string = "";
  @Input() defaultOdataFilters: string = "";
  @Input() maxHeightVh: number = 68;
  @Input() exportToExcel: boolean = false;
  @Input() expandedEnquiryNo: string = "";
  @Input() headerParametersValues: HeaderParametersValues = new HeaderParametersValues();
  @Input() roundDigits: RoundDigit[] = new Array();
  @Input() roundDigitsItems: RoundDigit[] = new Array();
  @Input() enableDoubleClick: boolean = false;
  @Input() enableStickyColumnsAtStart: boolean = false;
  @Input() columnToFixInSettings: string[] = [];
  @Input() origin: string = "";
  @Input() filtersToHide: string[] = new Array();
  @Input() filterScope: string = "";
  @Input() resizableColumnRedistribute: boolean = false;



  /* ROW GRID */
  @Input() columnsToHideRow: string[] = new Array();
  @Input() dataSetRow: any[] = new Array();
  @Input() expandedGridVirtualScroll: boolean = false; // opt-in row virtualization for the expanded items grid
  @Input() expandedGridVirtualScrollMinRows: number = 50;
  @Input() customRenderers: { [key: string]: (row: any) => { template: TemplateRef<any>, context: any } } = {};
  @Input() customHeaderRenderers: { [key: string]: () => { template: TemplateRef<any>, context: any } } = {};
  @Input() expandedGridDescriptionExtraTemplate?: TemplateRef<any>;
  @Input() expandedGridDescriptionExtraContext: any = null;

  // **** oDATA SETTINGS //
  @Input() oDataUrl: string = "";


  // Inputs to allow prefilled filters
  @Input() showFiltersOnLoad = false;
  @Input() initialFilters?: Array<OdataGridInitialFilters> = [];

  @Output() rowClick: EventEmitter<any> = new EventEmitter(); // EVENT EMITTED ON ROW CLICK WITH NO SELECTION SETTED
  @Output() rowsSelected: EventEmitter<any[]> = new EventEmitter(); // EVENT ON CHECKBOX SELECTION
  @Output() rowEditClick: EventEmitter<any> = new EventEmitter(); // EVENT ON EDIT ICON
  @Output() rowDeleteClick: EventEmitter<any> = new EventEmitter(); // EVENT ON DELETE ICON
  @Output() customIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onCloseDialogSettings: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateConfiguration: EventEmitter<GridConfiguration> = new EventEmitter(); // Emtted everytime that the GridCOnfiguration is changed
  @Output() onGetOdataEntity: EventEmitter<GridColumn[]> = new EventEmitter();
  @Output() onCellClick: EventEmitter<ClickedCell> = new EventEmitter();
  @Output() onActiveFiltersUpdate: EventEmitter<ActiveFilter[]> = new EventEmitter();
  @Output() customIconContextMenuClick: EventEmitter<any> = new EventEmitter();

  @ViewChild('hScroll', { static: false }) hScroll!: ElementRef<HTMLDivElement>;
  @ViewChildren('oDataStickyContainer') stickyContainers!: QueryList<ElementRef>;
  stickyContainerWidth: number = 0;

  subscriptions: Subscription = new Subscription();

  /** INTERNAL VARS */
  cellWidthPerc?: number;
  selectedIndex?: number = -1;
  allSelected: boolean = false;
  pageDataSet: any[] = new Array();
  sortedDataset: any[] = new Array();
  pageIndex: number = 1;
  totPages: number = 0;
  selectedRows: any[] = new Array();
  sortedCol: string = "";
  sortDirection: string = "";
  //gridColumns: string[] = new Array();
  searchedValue: string = '';
  isLoaded: boolean = false;
  customIcoColsStart: CustomIcoCol[] = new Array();
  customIcoColsEnd: CustomIcoCol[] = new Array();
  calculatedColsStart: CalculatedCols[] = new Array();
  calculatedColsEnd: CalculatedCols[] = new Array();
  activeFilters: ActiveFilter[] = new Array();
  //optionsBoolean: SelectOption[] = new Array();
  gridW: number = 0;
  gridFilters: GridFilter[] = new Array();
  oldGridSorting: string = "";
  oldGridConfiguration: string = "";
  anyGridError: boolean = false;
  allColumns: GridColumn[] = new Array();
  maxWidthRow: number = 0;
  /* columnsWidth: ColumnWidth[] = new Array(); */
  inputFilterTimeoutId: any;
  callOdataSubscription?: Subscription;
  private latestODataRequestId: number = 0;
  resizingFlag = { isResizing: false };
  containerWidth: number = 0;
  rowExpandedWidth: number = 0;
  recalculateColumnsWidth: boolean = false;

  // New Filter Mnagement
  filters: any[] = new Array();
  oDataFilterMaps: ODataGridFilterMap[] = new Array();
  hasUoms: boolean = true;
  isExpandedRow: boolean = false;
  stickyFirstColLeft: number = 0;
  private dateOnlyColumnsSet: Set<string> = new Set<string>();
  private defaultEnquiryBookUomFiltersByColumn: { [columnName: string]: string[] } = {};
  private filterValuesLoaded = false;
  private filterValuesLoading = false;

  constructor(@Inject(DOCUMENT) private document: Document, private translateService: TranslateService, private globals: Globals,
    private oDataService: TeiasoftOdataService, private teiasoftLoader: TeiasoftLoaderService, private utilsService: UtilsService,
    private teiasoftGridService: TeiasoftGridService, private teiasoftToaster: TeiasoftToasterService, private datePipe: DatePipe,
    private beservice: BackendService, private route: ActivatedRoute) {
    // $(window).resize(() => {
    //   this.setDimensionsGOD('resize');
    // });

    this.isLoaded = false;
    this.setSelectable();
  }

  ngOnInit(): void {
    this.anyGridError = false;
    this.updateDateOnlyColumnsSet(this.dateOnlyColumns);
    window.addEventListener('resize', this.onWindowResize);
    // this.setupInitialFilters();
  }


  ngOnDestroy(): void {
    this.sortedCol = '';
    this.sortDirection = '';
    this.callOdataSubscription?.unsubscribe();
    this.subscriptions.unsubscribe();
    window.removeEventListener('resize', this.onWindowResize);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setOptionsBoolean();
      this.isLoaded = true;
    }, 0);

  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['expandedEnquiryNo']) {
      // Perform additional actions if needed
      this.expandedEnquiryNo = changes["expandedEnquiryNo"].currentValue
      this.scheduleAutoExpand();
      setTimeout(() => this.scrollHorizontallyToLeft());
    }

    if (changes && changes["filterable"]) {
      this.filterable = changes["filterable"].currentValue;
      if (this.filterable) {
        this.maxHeightVh = 60;
        this.ensureODataFilterValuesLoaded();
      }
      else
        this.maxHeightVh = 68;
      // if (this.filterable == true) this.onApplySettings(this.gridConfiguration); // MQF-468
    }

    if (changes && changes["dateFormat"]) {
      this.dateFormat = changes["dateFormat"].currentValue;
    }

    if (changes && changes["columnToFixInSettings"]) {
      this.columnToFixInSettings = changes["columnToFixInSettings"].currentValue;
    }

    if (changes && changes["enableDoubleClick"]) {
      this.enableDoubleClick = changes["enableDoubleClick"].currentValue;
    }

    if (changes && changes["enableStickyColumnsAtStart"]) {
      this.enableStickyColumnsAtStart = changes["enableStickyColumnsAtStart"].currentValue;
    }

    if (changes && changes["origin"]) {
      this.origin = changes["origin"].currentValue;
    }

    if (changes && changes["filterScope"]) {
      this.filterScope = changes["filterScope"].currentValue || "";
      if (!changes["filterScope"].firstChange && this.oDataUrl == 'Enquiries') {
        this.resetFilterValuesState();
        this.ensureODataFilterValuesLoaded();
      }
    }

    if (changes && changes["dateOnlyColumns"]) {
      this.dateOnlyColumns = changes["dateOnlyColumns"].currentValue || [];
      this.updateDateOnlyColumnsSet(this.dateOnlyColumns);
    }

    if (changes && changes["dateTimeFormat"]) {
      this.dateTimeFormat = changes["dateTimeFormat"].currentValue;
    }

    if (changes && changes["roundDigits"]) {
      this.roundDigits = new Array();
      this.roundDigits = changes["roundDigits"].currentValue;
      this.setRoundDigits();
    }

    if (changes && changes["roundDigitsItems"]) {
      this.roundDigitsItems = new Array();
      this.roundDigitsItems = changes["roundDigitsItems"].currentValue;
    }

    if (changes && changes["headerParametersValues"]) {
      this.headerParametersValues = new HeaderParametersValues();
      this.headerParametersValues = changes["headerParametersValues"].currentValue;
      this.setFilters();
    }

    if (changes && changes["selectable"]) {
      this.selectable = changes["selectable"].currentValue;
      this.setSelectable();
    }

    if (changes && changes["multiSelection"]) {
      this.multiSelection = changes["multiSelection"].currentValue;
      this.setSelectable();
    }


    if (changes && changes["exportToExcel"]) {
      this.exportToExcel = changes["exportToExcel"].currentValue;
      if (this.exportToExcel) this.exportEnquiryToExcel();
    }

    if (changes && changes["customIcoCols"]) {
      this.customIcoCols = new Array();
      this.customIcoCols = changes["customIcoCols"].currentValue;
      this.setCustomIcoCols();
    }

    if (changes && changes["calculatedCols"]) {
      this.calculatedCols = new Array();
      this.calculatedCols = changes["calculatedCols"].currentValue;
      this.calculatedColsStart = new Array();
      this.calculatedColsStart = this.calculatedCols.filter(x => x.position == 'start');
      this.calculatedColsEnd = new Array();
      this.calculatedColsEnd = this.calculatedCols.filter(x => x.position == 'end');
    }

    if (changes && changes["dataSet"]) {
      this.dataSet = new Array();
      this.dataSet = changes["dataSet"].currentValue;
      this.sortedDataset = new Array();
      this.sortedDataset = this.dataSet;
      this.setPagination();
      // this.setDimensionsGOD("dataSet");
      this.setFilters();
    }

    if (changes && changes["oDataUrl"]) {
      this.oDataUrl = changes["oDataUrl"].currentValue;
      this.resetFilterValuesState();
      if (this.oDataUrl != '' && this.oDataUrl != undefined) {
        this.getODataEntityMetadata();
      }
      this.pageIndex = 1; // reset pagination
    }

    if (changes && changes["clearFilters"]) {
      this.clearFilters = changes["clearFilters"].currentValue;
      if (this.clearFilters) this.clearAllFilters();
    }

    if (changes && changes["showSettingsDialog"]) {
      if (changes["showSettingsDialog"].currentValue) {
        this.showSettingsDialog = changes["showSettingsDialog"].currentValue;
        let _tempConfiguration: string = JSON.stringify(this.gridConfiguration);
        this.gridConfiguration = new GridConfiguration();
        this.gridConfiguration = JSON.parse(_tempConfiguration);
        this.oldGridConfiguration = _tempConfiguration;
        _tempConfiguration = "";
        this.oldGridSorting = JSON.stringify(this.gridConfiguration.gridSortings!);
      }
      this.refreshColumnsWidth();
    }

    if (changes && changes["refreshGridKey"]) {
      this.refreshGridKey = changes["refreshGridKey"].currentValue; // maybe this is not necessary => keep it to debug
      if (!changes["refreshGridKey"].firstChange)
        this.checkGridConfiguration(false, true);
    }

    if (changes && changes["gridConfiguration"]) {
      const incomingConfiguration = changes["gridConfiguration"].currentValue ?? new GridConfiguration();
      // After a column resize the parent echoes back the configuration we just emitted:
      // the DOM is already aligned with it, so re-syncing and recalculating would only cause churn
      const isSameConfiguration = !changes["gridConfiguration"].firstChange &&
        JSON.stringify(incomingConfiguration) === JSON.stringify(this.gridConfiguration);
      this.gridConfiguration = _.cloneDeep(incomingConfiguration);
      if (!isSameConfiguration) {
        this.syncColumnsFromGridConfiguration();
        this.refreshColumnsWidth();
      }
    }

    if (changes && changes["columnsWidth"]) {
      this.columnsWidth = new Array();
      this.columnsWidth = changes["columnsWidth"].currentValue;
    }

    if (changes && changes["columnsToHideRow"]) {
      this.columnsToHideRow = new Array();
      this.columnsToHideRow = changes["columnsToHideRow"].currentValue;
    }

    if (changes && changes["dataSetRow"]) {
      this.maxWidthRow = $('.tg-cnt-ext').width() * 0.95;
      this.dataSetRow = new Array();
      this.dataSetRow = changes["dataSetRow"].currentValue;
    }

    if (changes && changes["filtersToHide"]) {
      this.filtersToHide = new Array();
      this.filtersToHide = changes["filtersToHide"].currentValue;
    }

    if (changes && changes["showFiltersOnLoad"]) {
      this.showFiltersOnLoad = changes["showFiltersOnLoad"].currentValue;
      if (this.showFiltersOnLoad) {
        this.filterable = true;
        this.maxHeightVh = 60;
        this.ensureODataFilterValuesLoaded();
      }
    }

    if (changes && changes["initialFilters"]) {
      this.initialFilters = changes["initialFilters"].currentValue || [];
      if (this.gridFilters && this.gridFilters.length > 0) {
        for (const filter of this.gridFilters) {
          const initValue = this.initialFilters?.find(i => i.column == filter.column);
          filter.initialValue = initValue ? initValue.value : undefined;
        }
      }

      if (!changes["initialFilters"].firstChange) {
        this.applyInitialFiltersAndRefresh();
      }
    }

    /*     if (changes && changes["cellSpecialStyles"]){
          this.cellSpecialStyles = new Array();
          this.cellSpecialStyles = changes["cellSpecialStyles"].currentValue();
        } */
  }

  onWindowResize = (): void => {
    this.refreshColumnsWidth();
  };

  setupInitialFilters(): void {
    // read from query params if provided
    const qp = this.route.snapshot.queryParamMap.get('filters');
    if (qp && (!this.initialFilters || this.initialFilters.length === 0)) {
      try {
        this.initialFilters = JSON.parse(atob(qp));
      } catch { /* ignore */ }
    }

    if (this.showFiltersOnLoad) {
      this.filterable = true; // ensures the filter bar is expanded/visible
    }

    if (this.initialFilters && this.initialFilters.length > 0) {
      this.applyInitialFilters(this.initialFilters);
    }
  }

  private applyInitialFilters(filters: typeof this.initialFilters) {

    for (const f of filters!) {
      const col = f.column;

      if (this.isSpecialFilter(col)) {
        this.onSelectedFilterOptions([f.value], col, f.type, true)
      }
      else {

        switch (f.type) {
          case 'string':
          case 'any[]':
            this.onInputChange(f.value ?? '', col, f.type, true);
            break;

          case 'number':
            this.onInputChangeNumericRange({
              operator: f.op ?? 'eq',
              value: f.value,
              valueTo: f.valueTo,
              uom: f.uom
            }, col, 'number');
            if (f.uom) {
              this.selectedUomChange(f.uom, col);
            }
            break;

          // case 'date':
          //   // Your date component fires onChange with {operator, from, to} (infer from your use)
          //   // If your handler expects a Date or ISO string, pass accordingly.
          //   this.onChangeData({
          //     operator: f.op ?? (f.valueTo ? 'between' : 'eq'),
          //     from: f.value,
          //     to: f.valueTo
          //   }, col);
          //   break;

          case 'select':
            // teiasoft-select emits (onSelected) with the chosen value

            this.onSelectedBoolean(f.value, col);
            break;
        }
      }
    }

    this.callOData();

  }

  private applyInitialFiltersAndRefresh(): void {
    if (!this.initialFilters || this.initialFilters.length === 0) {
      return;
    }

    this.activeFilters = new Array();
    this.applyInitialFilters(this.initialFilters);
  }

  /* FILTERS - SET DATA FOR SELECT */
  setOptionsBoolean(): SelectOption[] {
    let _ret: SelectOption[] = new Array();
    let _item: SelectOption = new SelectOption();
    _item.text = '';
    _item.value = '';
    _ret.push(_item);
    _item = new SelectOption();
    _item.text = this.translateService.instant("grid.true");
    _item.value = true;
    _ret.push(_item);
    _item = new SelectOption();
    _item.text = this.translateService.instant("grid.false");
    _item.value = false;
    _ret.push(_item);

    return _ret;
  }

  setOptionsColumn(col: string): SelectOption[] {
    let _ret: SelectOption[] = new Array();
    _ret = this.teiasoftGridService.createSelectOptionList(col);
    return _ret;
  }

  /****************************************************************************************************************************/
  /*                                                  METHODS                                                                  */
  /***************************************************************************************************************************/

  /* GET oData ENTITY METADATA */
  getODataEntityMetadata() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.oDataService.discoverServiceMetadata(this.oDataUrl).subscribe(res => {
      this.teiasoftLoader.stop();
      if (res) {
        this.columnsGOD = new Array();
        this.allColumns = new Array();
        let _json: any = JSON.parse(res);
        let _x: number = 0;
        for (var key of Object.keys(_json)) {
          if (key.toString().toLowerCase() == 'quoteentities.odataentities') {
            for (var key2 of Object.keys(_json[key])) {
              if (key2.toString() == this.odataEntity) {
                for (var key3 of Object.keys(_json[key][key2])) {
                  if (!key3.toString().startsWith('$')) {
                    let _col: GridColumn = new GridColumn();
                    _col.id = _x;
                    _col.name = key3.toString();
                    let _type: string = "string";
                    if (_json[key][key2][key3]["$Type"] && !_json[key][key2][key3]["$Collection"]) {
                      _type = _json[key][key2][key3]["$Type"].toString().replace("Edm.", "").toLowerCase();
                    } else if (!_json[key][key2][key3]["$Type"] && _json[key][key2][key3]["$Collection"]) {
                      _type = 'any[]';
                    } else {
                      //empty
                    }
                    _col.type = (_type == 'int32' || _type == 'single' || _type == 'double') ? 'number' : (_type == 'int64' ? 'date' : _type);
                    _col.visible = true;
                    if (this.columnsToHideGOD && this.columnsToHideGOD.length > 0 && this.columnsToHideGOD.findIndex(c => c === key3.toString()) === -1) {
                      this.columnsGOD.push(_col);
                    }
                    this.allColumns.push(_col);
                    _x++;
                  }
                }
              }
            }
          }
        }

        if (!this.columnsGOD || this.columnsGOD.length == 0) {
          console.error("[QuoteTool] Entity " + this.oDataUrl + " metadata is empty", res);
          this.anyGridError = true;
        } else {
          this.onGetOdataEntity.emit(this.allColumns);
          this.checkGridConfiguration(true, true);
          this.ensureODataFilterValuesLoaded();

        }
      }
    }));
  }

  /***
   * CHECK USER CONFIGURATION
   */
  checkGridConfiguration(firstCall: boolean, callOData: boolean) {
    // NO CONFIGURATION SAVED
    let _isChanged: boolean = false;
    if (!this.gridConfiguration.gridColumns) this.gridConfiguration.gridColumns = new Array();
    if (this.gridConfiguration.gridColumns!.length == 0) {
      for (var x = 0; x < this.columnsGOD.length; x++) {
        if (this.columnsToHideGOD.findIndex(c => c === this.columnsGOD[x].name!) == -1)
          this.gridConfiguration.gridColumns.push(this.columnsGOD[x]);
      }
      _isChanged = true;
    } else {
      //1. Check if every col in dat from BE exists in configuration
      for (var k = 0; k < this.columnsGOD.length; k++) {
        if (this.columnsToHideGOD.findIndex(c => c === this.columnsGOD[k].name!) == -1) {
          let _i: number = this.gridConfiguration.gridColumns!.findIndex(x => x.name == this.columnsGOD[k].name);
          if (_i == -1) {
            // MEANS THAT THERE'S A NEW COLUMN
            this.gridConfiguration.gridColumns!.push(this.columnsGOD[k]);
            _isChanged = true;
          }
        }
      }

      //2. Check if every col in grid configuration exists in BE
      let _temp: GridColumn[] = new Array();
      for (var k = 0; k < this.gridConfiguration.gridColumns!.length; k++) {
        let _i: number = this.columnsGOD!.findIndex(x => x.name == this.gridConfiguration.gridColumns![k].name);
        if (_i >= 0) {
          _temp.push(this.gridConfiguration.gridColumns![k])
        } else {
          _isChanged = true;
        }
      }
      this.gridConfiguration.gridColumns = new Array();
      this.gridConfiguration.gridColumns = JSON.parse(JSON.stringify(_temp));;
      this.columnsGOD = JSON.parse(JSON.stringify(this.gridConfiguration.gridColumns));
      _temp = new Array();

      //3. Check default view filter (from Toolbar)
      /* if (!this.activeFilters) this.activeFilters = new Array();
      let _iToRemove: number[] = new Array();
      for (var x=0; x < this.activeFilters.length; x++){
        if (this.activeFilters[x].isDefaultView) _iToRemove.push(x);
      }
      for (var x=0; x < _iToRemove.length; x++){
        this.activeFilters.splice(x, 1);
      }
      if (this.gridConfiguration.defaultFilterView != 'all'){
          let _item: ActiveFilter = new ActiveFilter();
          _item.columun = this.gridConfiguration.defaultFilterView!;
          _item.dateDirection ='';
          _item.isDefaultView = true;
          _item.operator = 'eq';
          _item.value = this.gridConfiguration.defaultFilterView! == 'SalesPerson' ? this.globals!.userLogged!.username! : this.globals!.userLogged!.office!;
          this.activeFilters.push(_item);
      }  */
    }

    // SAVE DATA INTO USER (ONLY IF IS CHANGED)
    //if (_isChanged) this.onUpdateConfiguration.emit(this.gridConfiguration);
    if (_isChanged) {
      this.utilsService.upsertGridConfiguration(this.gridConfiguration);
    }
    if (firstCall) this.setFilters();
    this.callOData();
  }

  /* oDATA CALL */
  callOData() {
    let top, skip: number | undefined = undefined;
    if (this.paginable) {
      // Calculate $top and $skip values based on current page and rows per page
      top = this.rowsPerPage;
      skip = (this.pageIndex - 1) * this.rowsPerPage;
    }

    let gridSortings = this.gridConfiguration.gridSortings!;

    // column sorting click overrides gridConfiguration.gridSortings 
    if (this.sortable && this.sortedCol != '' && this.gridConfiguration.gridColumns?.map(gc => gc.name).includes(this.sortedCol)) {
      let gs = new GridSorting();
      gs.column = this.sortedCol;
      gs.direction = this.sortDirection
      gridSortings = [gs];
    }

    if (!this.activeFilters || this.activeFilters.length == 0) this.teiasoftLoader.start();

    this.callOdataSubscription?.unsubscribe();
    const requestId = ++this.latestODataRequestId;

    this.callOdataSubscription = this.oDataService.callOData(this.oDataUrl, this.activeFilters, gridSortings, this.gridConfiguration.defaultFilterView!, top, skip, this.defaultOdataFilters).subscribe({
      next: (res) => {
        if (requestId !== this.latestODataRequestId) {
          return;
        }

        this.dataSet = new Array();
        if (!this.activeFilters || this.activeFilters.length == 0) this.teiasoftLoader.stop();
        if (res && res.value!.length > 0) {
          this.dataSet = res.value!;
          /* this.setPagination(); */

          this.setRoundDigits();
        }
        this.setPagination();
        this.scheduleExpandedRowReconcile();

        // if (this.sortable && this.sortedCol != ''){
        //   let _tempArray: any[] = new Array();
        //   for (var x = 0; x < this.dataSet.length; x++) {
        //     _tempArray.push(this.dataSet[x]);
        //   }
        //   if (this.sortDirection == 'asc') {
        //     this.sortedDataset = this.orderByArrayAsc(_tempArray, this.sortedCol);
        //   } else if (this.sortDirection == 'desc') {
        //     this.sortedDataset = this.orderByArrayDesc(_tempArray,  this.sortedCol);
        //   } 

        //   this.pageDataSet = new Array();
        //   this.pageDataSet = this.sortedDataset;

        // } else {
        //   this.setPagination();
        // }
        //setTimeout(() => this.setDimensionsGOD('callOData'), 250); // GBR 22/10/2024 - MQF-469: disabilitato perchè all caricamento dei dati ricalcola (erronamente) la dimensione colonne
        setTimeout(() => {
          if (requestId !== this.latestODataRequestId) {
            return;
          }

          // this.setDimensionsGOD('callOData');
          this.refreshColumnsWidth();

          /* this.checkGridConfiguration(true);
          this.containerWidth = $('.tgodata-header').width() */
        }, 150);
      },
      error: () => {
        if (requestId !== this.latestODataRequestId) {
          return;
        }

        if (!this.activeFilters || this.activeFilters.length == 0) this.teiasoftLoader.stop();
      }
    });
  }

  // getColValue(row: any, col: GridColumn): any {
  //   if (row[col.name!] == undefined || row[col.name!] == null)
  //     return "";

  //   if (col.type == 'any[]') {
  //     if (row[col.name!].length > 0) {
  //       return row[col.name!].join(", ");
  //     } else {
  //       return "";
  //     }
  //   }

  //   if (col.type == 'number') {
  //     let _value: number = row[col.name!];
  //     if (_value != undefined && _value.toString().indexOf('.') != -1 && _value.toString().split(".")[1].length > 4) {
  //       return _value.toFixed(4);
  //     }
  //   }
  //   return row[col.name!];
  // }

  geBooleanValue(row: any, col: GridColumn): string {

    if (row[col.name!] === true) return this.translateService.instant("noTranslations.yes");
    if (row[col.name!] === false) return this.translateService.instant("noTranslations.no");

    return '';
  }

  getColValue(row: any, col: GridColumn): any {
    // Handle undefined or null values
    if (row[col.name!] === undefined || row[col.name!] === null) {
      return "";
    }

    // Check if the column requires a UOM
    const uomColumnsMapping: any = {
      OutsideDiameter: ["OdUom"],
      InsideDiameter: ["IdUom"],
      WallThickness: ["WtUom"],
      TotalWeight: ["TotalWeightUom"],
      TotalBookedWeight: ["BookedTotalWeightUom", "TotalWeightUom"],
      BookedTotalWeight: ["BookedTotalWeightUom", "TotalWeightUom"],
      TotalLength: ["TotalLengthUom"],
      TotalBookedLength: ["TotalBookedLengthUom", "TotalLengthUom"],
      BookedTotalLength: ["TotalBookedLengthUom", "TotalLengthUom"]
    };

    const columnName = col.name!;
    const value = row[columnName];
    const uomColumns = uomColumnsMapping[columnName] || [];
    const uom = uomColumns.map((uomCol: string) => row[uomCol]).find((uomValue: any) => uomValue != null && uomValue !== '') || "";

    // Handle array type columns
    if (col.type === "any[]") {
      if (value.length > 0) {
        return value.join(", ");
      } else {
        return "";
      }
    }

    // Handle numeric columns
    if (col.type === "number") {
      let _value: number = Number(value);
      const unitSystem = row["UnitSystem"];
      const roundDigitCfg = this.roundDigits?.find(x => x.fieldName?.toLowerCase() === columnName.toLowerCase());
      const digitsForCol = roundDigitCfg
        ? (unitSystem === 'Imperial' ? roundDigitCfg.imperialDigits : roundDigitCfg.metricDigits)
        : undefined;

      if (typeof digitsForCol === 'number') {
        if (_value !== undefined && _value.toString().includes(".") && _value.toString().split(".")[1].length > digitsForCol) {
          _value = parseFloat(_value.toFixed(digitsForCol));
        }
      } else {
        if (_value !== undefined && _value.toString().includes(".") && _value.toString().split(".")[1].length > 4) {
          _value = parseFloat(_value.toFixed(4));
        }
      }

      // Concatenate UOM for numbers
      return uom ? `${_value} ${uom}` : _value;
    }

    // Return concatenated value and UOM for other types, or just value
    return uom ? `${value} ${uom}` : value;
  }
  getDateDisplayFormat(col: GridColumn): string {
    return this.isDateOnlyColumn(col) ? (this.dateFormat || this.dateTimeFormat) : (this.dateTimeFormat || this.dateFormat);
  }

  getDateDisplayValue(row: any, col: GridColumn): Date | number | string | null {
    const value = row[col.name!];
    if (value === undefined || value === null || value === '') {
      return null;
    }

    if (this.isDateOnlyColumn(col)) {
      return getDateOnlyDisplayDate(value) || value;
    }

    return value;
  }

  getDateCssClass(col: GridColumn): string {
    return this.isDateOnlyColumn(col) ? 'date2' : 'date1';
  }

  isDateOnlyColumn(col: GridColumn): boolean {
    if (!col || !col.name) {
      return false;
    }

    return this.dateOnlyColumnsSet.has(col.name.toLowerCase());
  }

  private updateDateOnlyColumnsSet(columns?: string[]): void {
    const normalized = (columns ?? []).map(name => name.toLowerCase());

    this.dateOnlyColumnsSet = new Set<string>(normalized);
  }



  getCellSpecialStyles(col: GridColumn, param: string, i: number): string {
    if (this.cellSpecialStyles.length == 0) return "";
    let _i: number = this.cellSpecialStyles.findIndex(x => x.colName == col.name!);
    if (_i == -1) {
      if (param == 'bgColor')
        return "#ffffff";
      else
        return "#232323";
    } else {
      if (param == 'bgColor') {
        let _sourceCol: string = this.cellSpecialStyles.find(x => x.colName == col.name)!.bgColorSourceData!;
        return 'rgb' + this.pageDataSet[i][_sourceCol];
      } else {
        return "#232323";
      }

    }

  }

  exportEnquiryToExcel() {
    this.teiasoftLoader.start();
    let _defView: string = "exportAll";
    if (this.gridConfiguration.defaultFilterView! == 'GetMy')
      _defView = "exportMy";

    if (this.gridConfiguration.defaultFilterView! == 'GetOffice')
      _defView = "exportOffice";

    this.subscriptions.add(this.oDataService.exportEnquiryToExcel(this.oDataUrl, this.activeFilters, this.gridConfiguration.gridSortings!, _defView).subscribe(res => {
      this.teiasoftLoader.stop();
      window.open(res["value"], "_blank");
    }));
  }

  setRoundDigits() {
    // ROUND DIGITS
    if (!this.roundDigits || this.roundDigits.length == 0) return;
    if (!this.dataSet || this.dataSet.length == 0) return;

    for (var k = 0; k < this.dataSet.length; k++) {
      let _unitSystem: string = this.dataSet[k]["UnitSystem"];
      for (const prop in this.dataSet[k]) {
        let _i: number = this.roundDigits.findIndex(x => x.fieldName?.toLowerCase() == prop.toLowerCase());
        if (_i != -1) {
          if (_unitSystem == 'Metric' && this.dataSet[k][prop] != null && this.dataSet[k][prop] != '')
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigits[_i].metricDigits!);

          if (_unitSystem == 'Imperial' && this.dataSet[k][prop] != null && this.dataSet[k][prop] != '')
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigits[_i].imperialDigits!);

          // If no unit system, apply metric by default
          if (!_unitSystem) {
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigits[_i].metricDigits!);
          }

        } /* else {
          if (_unitSystem == 'Metric' && this.dataSet[k][prop] != null)
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop].toFixed(2));
          
          if (_unitSystem == 'Imperial' && this.dataSet[k][prop] != null)
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop].toFixed(2));
        } */
      }
    }

  }
  /**
   * CUSTOM ICO COLS
   */
  setCustomIcoCols() {
    this.customIcoColsStart = new Array();
    this.customIcoColsStart = this.customIcoCols.filter(x => x.position == 'start');
    this.customIcoColsEnd = new Array();
    this.customIcoColsEnd = this.customIcoCols.filter(x => x.position == 'end');
  }

  /**
   * CHECK FOR CORRECT SELECTION
   */
  setSelectable() {
    if (!this.selectable) this.multiSelection = false;
  }

  /**
   * GRID DIMENSIONS
   */
  setDimensionsGOD(sender: string) {
    let _totColIcon: number = this.customIcoCols.length + this.calculatedCols.length;
    if (this.showDeleteIcon) _totColIcon++;
    if (this.showEditIcon) _totColIcon++;
    let _icoColsW: number = _totColIcon * (window.innerWidth * 0.024);
    let _colsNum: number = this.columnsGOD.filter(x => x.visible == true).length;
    let _colsHided: number = this.columnsGOD.filter(x => x.visible == false).length;
    let _colsW: number = _colsNum * ((window.innerWidth * 0.08) + (window.innerHeight * 0.016));
    // Calculate HowMany BigColumns we have
    let _bigColW: number = this.columnsWidth.length * (window.innerWidth * 0.3);
    this.gridW = _icoColsW + _colsW + _bigColW; // + (_colsHided*20);

    //CHECK IF GRID IS BIGGER THAT THE SUMMARY OF columnsGOD
    let _refGridW: number = $('.tg-cnt-ext').width();
    if (_refGridW > this.gridW) {
      this.gridW = _refGridW - 8; // remove 8px to consider scroolbar width
      let _w: number = this.gridW / _colsNum;
      $('.tg-cell').css("width", _w + 'px');
      $('.tg-cell-auto-width').css("width", _w + 'px');
      // $('.tg-cnt-ext').css("overflow-x", "hidden"); // now that web support columnsGOD resizing, showing overflow is fine
    }

    // MQF-338
    setTimeout(() => {

      this.containerWidth = $('.tgodata-header').width(); // -(window.innerWidth*0.05);
    }, 1000);

    //this.rowExpandedWidth = $('.tg-cnt-ext').width() - 20;
    /* if (this.containerWidth > 0)
      this.containerWidth = this.containerWidth;
    else
      this.containerWidth = $('.tgodata-header').width() -(window.innerWidth*0.05); */
  }

  refreshColumnsWidth() {
    this.recalculateColumnsWidth = true;
    setTimeout(() => {
      this.recalculateColumnsWidth = false;
    }, 150);

    // Wait for view to initialize, then get the first sticky container's width
    setTimeout(() => {
      if (this.stickyContainers.first) {
        this.stickyContainerWidth = this.stickyContainers.first.nativeElement.offsetWidth;
      }
    });
  }

  private syncColumnsFromGridConfiguration(): void {
    if (!this.gridConfiguration?.gridColumns || this.gridConfiguration.gridColumns.length == 0) return;

    this.columnsGOD = _.cloneDeep(this.gridConfiguration.gridColumns);
    this.setFilters();
  }

  /* CLER FILTERS */
  clearAllFilters() {
    this.clearFilters = true;
    this.activeFilters = new Array();
    this.onActiveFiltersUpdate.emit(this.activeFilters);
    this.setPagination();
  }

  /**
   * CALCULATE columnsGOD
   */
  calculateCol(col: CalculatedCols, row: any): string {
    let _calc: CalculatedCols = new CalculatedCols();
    _calc = this.teiasoftGridService.getCalculatedCol(col, row);
    return _calc.icon!;
  }

  /** PAGINATION */
  public setPagination(): void {
    if (!this.pageDataSet) this.pageDataSet = new Array();
    // if (this.paginable) {
    //   this.pageDataSet = this.dataSet.slice((this.pageIndex - 1) * this.rowsPerPage, this.pageIndex * this.rowsPerPage);
    //   this.totPages = Math.ceil(this.dataSet.length / this.rowsPerPage);
    //   //if (this.totPages == 0) this.totPages = 1;
    // } else {
    this.pageDataSet = this.dataSet;
    // }
  }

  /* SET FILTERS OBJECT */
  setFilters() {
    this.gridFilters = new Array();
    let _temp: GridColumn[] = new Array();

    // GBR 01/07/2024 - MQF-372
    //_temp = this.columnsGOD.filter(x => x.visible == true);
    _temp = JSON.parse(JSON.stringify(this.columnsGOD));
    // END

    for (var x = 0; x < _temp.length; x++) {
      let _item: GridFilter = new GridFilter();
      _item.column = _temp[x].name!;
      let _filterType = _temp[x].type!;
      if (_temp[x].type! == 'boolean')
        _filterType = 'select';

      /*     if (_temp[x].name == 'LastRevisionDate' || _temp[x].name == 'CreationDate')
            _filterType = 'datetime-local'; */


      // GBR 26/02/2024 - MQBF-15
      /* if (_temp[x].type! == 'boolean') 
        _filterType = 'select';
      else if (_temp[x].type! == 'any[]') 
        _filterType = 'any[]';
      else
        _filterType = 'string'; */
      /*** END MQF 15 */

      _item.filterType = _filterType;
      _item.visible = _temp[x].visible;
      _item.filterVisible = this.filtersToHide.findIndex(f => f == this.columnsGOD[x].name!) == -1 ? true : false;
      _item.optionsList = new Array();
      if (_temp[x].type! == 'boolean') {
        _item.optionsList = this.setOptionsBoolean();
      }

      if (_temp[x].type! == 'number') {
        _item.optionsList = this.getUoms(_temp[x].name!);
      }

      /*  else if (_temp[x].type! == 'any[]'){
        _item.optionsList = this.setOptionsColumn(_item.column);
      } */

      const initValue = this.initialFilters?.find(i => i.column == _item.column);
      if (initValue) {
        _item.initialValue = initValue.value;
      }

      this.gridFilters.push(_item);
    }

    _temp = new Array();
  }

  getColNameForTranslation(colName: string): string {
    return colName.substring(0, 1).toUpperCase() + colName.substring(1, colName.length);
  }

  isCellBig(col: string): boolean {
    if (this.columnsWidth.findIndex(x => x.colName == col) != -1)
      return true;
    else
      return false;
  }

  customIcoColDisabled(col: CustomIcoCol, row: any): boolean {
    let _status: string = row["OfferStatus"];
    if (col.action == 'editEnquiry' && !this.utilsService.isAuthorized("Office", "EditEnquiry", row["SalesOfficeId"])) return true;
    if (col.action == 'editEnquiry' && (_status != 'Header' && _status != 'Open' && _status != 'Edit')) return true;

    if (typeof col.disabled === 'function' ? col.disabled(row) : col.disabled)
      return true;

    return false;
  }

  getCustomIcoColColor(col: CustomIcoCol, row: any): string | null {
    return col.getColor?.(row) ?? col.color ?? null;
  }

  customMenuVoiceDisabled(action: string, row: any): boolean {
    let _status: string = row["OfferStatus"];

    if (_status == 'Frozen' && (action !== 'acceptEnquiry' && action !== 'refuseEnquiry')) {
      return true; // disable all actions on frozen status
    }

    if ((action == 'closeEnquiry' || action == 'changeStatus') && !this.utilsService.isAuthorized("Office", "EditEnquiry", row["SalesOfficeId"])) return true;
    // if (action == 'duplicateEnquiry' && !this.utilsService.isAuthorized("Office", "CreateEnquiry", row["SalesOfficeId"])) return true; // MP: Removed as duplication is always allowed - 01-10-2024
    if (action == 'closeEnquiry' && (_status != 'Open' && _status != 'Header' && _status != 'SentToCustomer' && _status != 'Edit')) return true;
    if (action == 'showDocumentTemplate' && !this.utilsService.isAuthorized("Office", "CreateQuotation", row["SalesOfficeId"])) return true;
    if ((action == 'reopenEnquiry') && (_status != 'SentToCustomer' || !this.utilsService.isAuthorized("Office", "EditEnquiry", row["SalesOfficeId"]))) return true;

    const { FeasibilityStatus, CostsStatus, DeliveryStatus } = row;
    const tv = 'TotallyValidated';
    if (action === 'showDocumentTemplate') {
      // Disable 'showDocumentTemplate' when status is not Open/Edit or any status is not TotallyValidated
      const isAllowedOfferStatus = _status === 'Open' || _status === 'Edit';
      if (!isAllowedOfferStatus || FeasibilityStatus !== tv || CostsStatus !== tv || DeliveryStatus !== tv) {
        return true;
      }
    }

    // Duplicate
    if (action == 'duplicateEnquiry' && !this.utilsService.isAuthorized("Office", "CreateEnquiry", row["SalesOfficeId"])) return true; // don't have the permission
    if (action == 'duplicateEnquiry' && (_status == 'Itdcr')) return true; // can't duplicate itdcr


    // ITDCR
    if (action === 'openITDCR') {

      if (!this.utilsService.isAuthorized("Office", "EditEnquiry", row["SalesOfficeId"])) return true; // don't have the permission
      if (_status !== 'Edit' && _status !== 'Itdcr') { // invalid status
        return true;
      }
    }

    return false;
  }


  getColumnWidth(col: GridColumn): string | null {
    const columnConfiguration = this.gridConfiguration.gridColumns?.filter(c => c.name == col.name)[0];
    let width = columnConfiguration && columnConfiguration.width ? (columnConfiguration.width) : 0;
    return width > 0 ? width + 'px' : null;
  }

  getColumnWidthFilter(colName: string): string {
    return $('#col_header_' + colName + '_' + this.gridConfiguration.name).width();
  }

  /****************************************************************************************************************************/
  /*                                                  EVENTS                                                                  */
  /***************************************************************************************************************************/

  /**
   * FILTER ON KEY UP
   */
  onKeyupFilter(e: KeyboardEvent, col: string) {
    if (e.code.toLowerCase() == 'tab') return;
    let _value = $('#f' + col).val();
    this.filterData(_value, col, '');
  }

  onFilterInputKeyDown(e: KeyboardEvent) {
    // debugger
  }

  filterData(value: any, col: string, dateDirection: string, skipODataCall: boolean = false) {
    if (!this.activeFilters) this.activeFilters = new Array();
    let _i: number = this.activeFilters.findIndex(x => x.columun == col);
    if (_i == -1) {
      if (value != undefined && value.toString() != '') {
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = col;
        _item.value = value; // dateDirection == '' ? value : new Date(value).getTime();
        _item.dateDirection = dateDirection;
        let _filterType: string = this.gridFilters.find(x => x.column == col)!.filterType!;
        let _operator: string = '';
        if (_filterType == 'string') _operator = 'contains';
        if (_filterType == 'select' || _filterType == 'number') _operator = 'eq';
        if (_filterType == 'any[]') _operator = 'in';
        // GBR 26/02/2024 - MQBF-15 - MQBF - 21
        if (_filterType == 'number') {
          let _val: any = this.utilsService.checkDecimal(_item.value!);
          if (_val != 'error') {
            _item.value = _val + "d";
          } else {
            this.teiasoftToaster.show("error", this.translateService.instant('errors.wrongFormatValue'));
            return;
          }
          //_item.value = _item.value + "d";
        }
        /**** END */
        _item.operator = _operator;
        _item.isDefaultView = false;
        this.activeFilters.push(_item);
      }
    } else {
      if (value != undefined && value.toString() != '') {
        this.activeFilters[_i].value = value; // = dateDirection == '' ? value : new Date(value).getTime();
        this.activeFilters[_i].dateDirection = dateDirection;
        // MQBF- 21
        let _filterType: string = this.gridFilters.find(x => x.column == col)!.filterType!;
        if (_filterType == 'number') {
          let _val: any = this.utilsService.checkDecimal(this.activeFilters[_i].value!);
          if (_val != 'error') {
            this.activeFilters[_i].value = _val + "d";
          } else {
            this.teiasoftToaster.show("error", this.translateService.instant('errors.wrongFormatValue'));
            return;
          }
          //_item.value = _item.value + "d";
        }
      } else {
        this.activeFilters.splice(_i, 1);
      }
    }

    this.onActiveFiltersUpdate.emit(this.activeFilters);
    if (!skipODataCall)
      this.callOData();
  }

  filterData_OLD(value: any, col: string, dateDirection: string) {
    if (!this.activeFilters) this.activeFilters = new Array();
    let _i: number = this.activeFilters.findIndex(x => x.columun == col);
    if (_i == -1) {
      if (value.toString() != '') {
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = col;
        _item.value = dateDirection == '' ? value : new Date(value).getTime();
        _item.dateDirection = dateDirection;
        let _filterType: string = this.gridFilters.find(x => x.column == col)!.filterType!;
        let _operator: string = '';
        if (_filterType == 'string') _operator = 'contains';
        if (_filterType == 'select' || _filterType == 'number') _operator = 'eq';
        if (_filterType == 'any[]') _operator = 'in';
        // GBR 26/02/2024 - MQBF-15
        if (_filterType == 'number' && this.isDecimal(_item.value)) {
          _item.value = _item.value + "d";
        }
        /**** END */
        _item.operator = _operator;
        _item.isDefaultView = false;
        this.activeFilters.push(_item);
      }
    } else {
      if (value.toString() != '') {
        this.activeFilters[_i].value = dateDirection == '' ? value : new Date(value).getTime();
        this.activeFilters[_i].dateDirection = dateDirection;
      } else {
        this.activeFilters.splice(_i, 1);
      }
    }
    this.callOData();
  }

  isDecimal(n: number) {
    return (n - Math.floor(n)) !== 0;
  }

  /**
   * EVENT ON ROW CLICK (ONLY FOR SELECTABLE == FALSE)
   */
  onRowClick(e: Event, row: any, i: number) {
    if (this.selectable) return;
    if (this.isExpandedRow) return;
    // MQF-427 - If enabled the row selection, clicking on the same selected row the selecition disapear
    if (this.selectedIndex == i)
      this.selectedIndex = -1;
    else
      this.selectedIndex = i;

    this.rowClick.emit(row);
  }

  private scrollHorizontallyToLeft() {
    const el = this.hScroll?.nativeElement;
    if (!el) return;

    // Smooth snap to the left edge
    el.scrollTo({ left: 0, behavior: 'smooth' });
  }

  private scheduleAutoExpand(): void {
    if (!this.expandedEnquiryNo) {
      return;
    }

    setTimeout(() => this.tryExpandRowByEnquiryNo(), 0);
  }

  /**
   * Called after the dataset has been (re)loaded (filter, sort, page change, refresh).
   * Rows are tracked by index, so the DOM of a previously expanded row (expanded container and
   * "collapse" icon) survives the reload and would show up on whatever row now sits at that index.
   * Re-expand the tracked enquiry at its new position, or clean up the expanded state when it is
   * no longer part of the dataset.
   */
  private scheduleExpandedRowReconcile(): void {
    if (!this.expandedEnquiryNo && !this.isExpandedRow) {
      return;
    }

    setTimeout(() => {
      if (!this.tryExpandRowByEnquiryNo()) {
        this.resetExpandedRowState();
      }
    }, 0);
  }

  private isExpandRowCol(col: CustomIcoCol): boolean {
    return (col.action || '').startsWith('expandRow');
  }

  /**
   * Index of the "expand row" custom icon column as used in the DOM ids of the icons
   * (the template numbers the start and end icon columns separately).
   */
  private getExpandRowColIndex(): number {
    const startIndex = this.customIcoColsStart.findIndex(col => this.isExpandRowCol(col));
    return startIndex !== -1 ? startIndex : this.customIcoColsEnd.findIndex(col => this.isExpandRowCol(col));
  }

  /**
   * Expands the row of `expandedEnquiryNo`, collapsing any other row.
   * Returns true when that row is expanded (already or now), false when it is not in the current page.
   */
  private tryExpandRowByEnquiryNo(): boolean {
    if (!this.expandedEnquiryNo || !this.pageDataSet || this.pageDataSet.length === 0) {
      return false;
    }

    const rowIndex = this.pageDataSet.findIndex(row => row["EnquiryNo"] == this.expandedEnquiryNo);
    if (rowIndex === -1) {
      return false;
    }

    const expandCol = this.customIcoCols.find(col => this.isExpandRowCol(col));
    const expandColIndex = this.getExpandRowColIndex();
    if (!expandCol || expandColIndex === -1) {
      return false;
    }

    const expRowSelector = '#expRow_' + this.oDataUrl + rowIndex;
    if ($(expRowSelector).length === 0) {
      return false;
    }
    if ($(expRowSelector).css("display") != 'none') {
      return true; // already expanded at this position
    }

    const collapsedIcon = expandCol.icon && expandCol.icon.length > 0 ? expandCol.icon[0] : '';
    const expandedIcon = expandCol.icon && expandCol.icon.length > 1 ? expandCol.icon[1] : collapsedIcon;

    for (var x = 0; x < this.pageDataSet.length; x++) {
      if (rowIndex != x) {
        $('#expRow_' + this.oDataUrl + x).css("display", 'none');
        $('#customIcon_' + this.oDataUrl + x + '_' + expandColIndex).attr('class', collapsedIcon + " tg-custom-icon");
      }
    }

    $(expRowSelector).fadeIn(0, () => {
      this.dataSetRow = new Array();
      $('#customIcon_' + this.oDataUrl + rowIndex + '_' + expandColIndex).attr('class', expandedIcon + " tg-custom-icon");
      this.customIconClick.emit(expandCol.action!.split("|")[0] + "|" + JSON.stringify(this.pageDataSet[rowIndex]));
    });

    this.isExpandedRow = true;
    this.selectedIndex = rowIndex;
    this.pageDataSet[rowIndex].expanded = true;
    return true;
  }

  /**
   * Collapses every row in the DOM and clears the expanded/selected state, exactly like a manual
   * collapse: the tracked enquiry is forgotten and the parent is asked to clear the items, so the
   * row stays closed even when it comes back into the dataset (e.g. after removing the filter).
   */
  private resetExpandedRowState(): void {
    if (!this.isExpandedRow) {
      return;
    }

    const expandCol = this.customIcoCols.find(col => this.isExpandRowCol(col));
    const expandColIndex = this.getExpandRowColIndex();
    const collapsedIcon = expandCol?.icon && expandCol.icon.length > 0 ? expandCol.icon[0] : '';

    for (var x = 0; x < this.pageDataSet.length; x++) {
      $('#expRow_' + this.oDataUrl + x).css("display", 'none');
      if (expandColIndex !== -1) {
        $('#customIcon_' + this.oDataUrl + x + '_' + expandColIndex).attr('class', collapsedIcon + " tg-custom-icon");
      }
    }

    this.isExpandedRow = false;
    this.selectedIndex = -1;
    this.dataSetRow = new Array();
    this.expandedEnquiryNo = "";
    this.customIconClick.emit('clearDataItems');
  }

  /**
   * ON ROW DOUBLE CLICK
   * @param evt 
   */
  onRowDoubleClick(row: any, i: number, action: string) {
    if (!this.enableDoubleClick) return;

    // MQF-428 - Expand row on double click
    let p: number = 2; // MP: WHAT IS IT ?  
    let col: any = { icon: ["fal fa-plus", "fal fa-minus"] };

    // COLLAPSE ALL OTHER ROWS
    for (var x = 0; x < this.pageDataSet.length; x++) {
      if (i != x) {
        $('#expRow_' + this.oDataUrl + x).css("display", 'none');
        $('#customIcon_' + this.oDataUrl + x + '_' + p).attr('class', col.icon![0] + " tg-custom-icon");
      }
    }

    // CHECK IF ROW IS EXPANDED
    if ($('#expRow_' + this.oDataUrl + i).css("display") == 'none') {
      // EXPAND THE ROW
      $('#expRow_' + this.oDataUrl + i).fadeIn(150, () => {
        this.dataSetRow = new Array();
        const iconSelector = '#customIcon_' + this.oDataUrl + i + '_' + p;
        $(iconSelector).attr('class', col.icon![1] + " tg-custom-icon");
        this.customIconClick.emit(action.split("|")[0] + "|" + JSON.stringify(row));
      });
      this.isExpandedRow = true;
      this.selectedIndex = i;
      setTimeout(() => this.scrollHorizontallyToLeft());

    } else {
      // COLLAPSE THE ROW
      $('#expRow_' + this.oDataUrl + i).fadeOut(150, () => {
        const iconSelector = '#customIcon_' + this.oDataUrl + i + '_' + p;
        $(iconSelector).attr('class', col.icon![0] + " tg-custom-icon");
        // CLEAN DATA GRID IN GRID
        this.dataSetRow = new Array();
        this.expandedEnquiryNo = "";
        this.customIconClick.emit('clearDataItems');
      });

      this.isExpandedRow = false;
      this.selectedIndex = -1;
    }

    row.expanded = this.isExpandedRow;


  }

  /***
   * EMIT EVENT ON MULTI SELECTION
   */
  onCheckAllRowsClick() {
    // SELECT ALL CHECKBOXES
    for (var x = 0; x < this.dataSet.length; x++) {
      const checkbox = document.getElementById('ckb_' + x) as HTMLInputElement | null;
      if (checkbox != null) {
        checkbox.checked = !this.allSelected;
      }
    }
    this.allSelected = !this.allSelected;
    this.selectedRows = new Array();
    if (this.allSelected && this.paginable) {
      for (var x = ((this.pageIndex - 1) * this.rowsPerPage); x < (this.pageIndex * this.rowsPerPage); x++) {
        this.selectedRows.push(this.dataSet[x]);
      }
    } else if (this.allSelected && !this.paginable) {
      for (var x = 0; x < this.dataSet.length; x++) {
        this.selectedRows.push(this.dataSet[x]);
      }
    }

    this.rowsSelected.emit(this.selectedRows);
  }

  /***
   * EMIT EVENT ON SINGLE SELECTION
   */
  onChkSelectRowClick(row: any, i: number) {
    if (!this.selectable) return;
    for (var x = 0; x < this.dataSet.length; x++) {
      const checkbox = document.getElementById('ckb_' + x) as HTMLInputElement | null;
      if (checkbox != null && x != i) {
        checkbox.checked = false;
      }
    }
    this.selectedRows = new Array();
    let _myCheckBox = document.getElementById('ckb_' + i) as HTMLInputElement | null;
    if (_myCheckBox != null && _myCheckBox.checked)
      this.selectedRows.push(row);

    this.rowsSelected.emit(this.selectedRows);
  }

  onChkSelectRowClick__OLD(row: any, i: number) {
    // SINGLE SELECTION
    if (this.selectable && !this.multiSelection) {
      for (var x = 0; x < this.dataSet.length; x++) {
        // Clear Previous selection
        const checkbox = document.getElementById('ckb_' + x) as HTMLInputElement | null;
        if (checkbox != null && x != i) {
          checkbox.checked = false;
        }
      }
      this.selectedRows = new Array();
      this.selectedRows.push(row);
    }

    // MULTISELECTION
    if (this.selectable && this.multiSelection) {
      if (!this.selectedRows) this.selectedRows = new Array();
      this.selectedRows.push(row);
    }

    this.rowsSelected.emit(this.selectedRows);
  }

  /***
   * PAGINATOR EVENTS
   */

  onClickPageBackToTop() {
    this.pageIndex = 1;
    this.callOData();
  }

  onClickPageBack() {
    if (this.pageIndex == 1) return;
    this.pageIndex -= 1;
    // this.setPagination();
    this.callOData();

  }

  onClickPageForward() {
    if (this.pageIndex == this.totPages) return;
    this.pageIndex += 1;
    // this.setPagination();
    this.callOData();
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  trackByColumn(_: number, col: GridColumn): string | number {
    return col?.name ?? _;
  }

  /***
   * SORT EVENT
   */
  onSortClick(colName: string, visible: boolean) {
    if (!visible) return;
    if (!this.sortable) return;
    if (this.resizingFlag.isResizing) return;  // Do not sort while resizing
    this.sortedDataset = new Array();
    this.sortedCol = colName;
    let _tempArray: any[] = new Array();
    for (var x = 0; x < this.dataSet.length; x++) {
      _tempArray.push(this.dataSet[x]);
    }
    if (this.sortDirection == '') {
      this.sortDirection = "asc";
      this.sortedDataset = this.orderByArrayAsc(_tempArray, colName);
    } else if (this.sortDirection == 'asc') {
      this.sortDirection = 'desc';
      this.sortedDataset = this.orderByArrayDesc(_tempArray, colName);
    } else {
      this.sortDirection = '';
      this.sortedDataset = this.dataSet;
    }


    if (this.paginable) {
      // apply server side sorting 
      this.pageIndex = 1;
      this.callOData();
    } else {
      this.pageDataSet = new Array();
      this.pageDataSet = this.sortedDataset;
      this.scheduleExpandedRowReconcile();
    }
  }

  getSortIcon(colName: string): string {
    if (!this.sortable) return "";
    if (this.sortedCol == '') return "";
    if (this.sortedCol == colName) {
      if (this.sortDirection == 'asc')
        return "&#8593;";
      else if (this.sortDirection == 'desc')
        return "&#8595;";
      else
        return "";
    } else {
      return "";
    }
  }

  orderByArrayAsc(values: any[], orderType: any) {
    return values.sort((a, b) => {
      const aValue = a[orderType];
      const bValue = b[orderType];

      if (aValue === null && bValue === null) return 0;
      if (aValue === null) return 1;
      if (bValue === null) return -1;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return aValue.localeCompare(bValue);
      }

      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    });
  }

  orderByArrayDesc(values: any[], orderType: any) {
    return values.sort((a, b) => {
      const aValue = a[orderType];
      const bValue = b[orderType];

      if (aValue === null && bValue === null) return 0;
      if (aValue === null) return 1;
      if (bValue === null) return -1;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return bValue.localeCompare(aValue);
      }

      return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    });
  }

  /**
   * EDIT/DELETE ICONS EVENT
   * @param e 
   * @param row 
   */
  onEditClick(e: Event, row: any) {
    e.stopPropagation();
    this.rowEditClick.emit(row);
  }

  onDeleteClick(e: Event, row: any) {
    e.stopPropagation();
    this.rowDeleteClick.emit(row);
  }

  /**
   * GET FOOTER CALC ITEMS
   * @returns 
   */
  getFooterCalcItems(): string {
    if (this.pageIndex * this.rowsPerPage > this.dataSet.length)
      return this.dataSet.length.toString();
    else
      return (this.pageIndex * this.rowsPerPage).toString();
  }

  /**
   * ON CONTEXT MENU MOUSE OUT
   * @param obj 
   */
  onCloseMenuContext(obj: string) {
    $("#" + obj).fadeOut(50);
  }

  /**
   * CLOSE ALL CONTEXT MENU
   */
  closeAllContextMenu() {
    for (var x = 0; x < this.pageDataSet.length; x++) {
      for (var k = 0; k < this.customIcoCols.length; k++) {
        let _obj: string = "context_" + x + "_" + k;
        $("#" + _obj).fadeOut(50);
      }
    }
  }

  /**
   * ON CUSTOM COL CLICK 
   * @param col 
   * @param row 
   * @param i 
   * @param p 
   * @returns 
   */
  onCustomIcoClick(event: MouseEvent, col: CustomIcoCol, row: any, i: number, p: number) {
    event.stopPropagation(); // Prevent row selection when clicking on custom icon
    this.selectedIndex = i;
    let action: string = col.action!;
    // CHECK WHICH ACTION I HAVE
    if (action == '') {
      //this.teiasoftToaster.show("info", this.translateService.instant("grid.noActionSetted"));
      if (col.isMenu) {
        this.closeAllContextMenu();
        if ($('#context_' + i + '_' + p).css("display") == 'none')
          $('#context_' + i + '_' + p).fadeIn(50);
        else
          $('#context_' + i + '_' + p).fadeOut(50);
      }
      return;
    }

    if (action != '' && action.indexOf("|") == -1) {
      this.customIconClick.emit(action + "|" + JSON.stringify(row));
    } else if (action != '' && action.indexOf("|") != -1) {
      let _data: string[] = new Array();
      _data = action.split("|");
      if (_data[0] == 'expandRow') {
        // COLLAPSE ALL OTHER ROWS
        for (var x = 0; x < this.pageDataSet.length; x++) {
          if (i != x) {
            $('#expRow_' + this.oDataUrl + x).css("display", 'none');
            $('#customIcon_' + this.oDataUrl + x + '_' + p).attr('class', col.icon![0] + " tg-custom-icon");
          }
        }

        // CHECK IF ROW IS EXPANDED
        if ($('#expRow_' + this.oDataUrl + i).css("display") == 'none') {
          // EXPAND THE ROW
          $('#expRow_' + this.oDataUrl + i).fadeIn(150, () => {
            this.dataSetRow = new Array();
            $('#customIcon_' + this.oDataUrl + i + '_' + p).attr('class', col.icon![1] + " tg-custom-icon");
            this.customIconClick.emit(action.split("|")[0] + "|" + JSON.stringify(row));
          });
          this.isExpandedRow = true;
          this.selectedIndex = i;
        } else {
          // COLLAPSE THE ROW
          $('#expRow_' + this.oDataUrl + i).fadeOut(150, () => {
            $('#customIcon_' + this.oDataUrl + i + '_' + p).attr('class', col.icon![0] + " tg-custom-icon");
            // CLEAN DATA GRID IN GRID
            this.dataSetRow = new Array();
            this.expandedEnquiryNo = "";
            this.customIconClick.emit('clearDataItems');
          });
          this.isExpandedRow = false;
          this.selectedIndex = -1;
        }

      } else {
        this.teiasoftToaster.show("error", this.translateService.instant("grid.actionUnknown") + " (" + _data[0] + ")");
      }
    }


    //this.customIconClick.emit(action + "|" + JSON.stringify(row));
  }

  /**
   * MENU VOICE ACTION
   * @param col 
   * @param row 
   */
  onMenuVoiceClick(action: string, row: any, obj: string) {
    if (this.customMenuVoiceDisabled(action, row)) return;
    this.onCloseMenuContext(obj);
    this.customIconClick.emit(action + "|" + JSON.stringify(row));
  }

  /**
   * CALCULATED COL CLICK
   * @param method 
   * @param row 
   */
  onCalculatedColClick(method: string, row: any) {
    //alert(method);
  }

  /**
   * ON SELECT FILTER VALUE
   * @param evt 
   * @param col 
   */
  onSelectedBoolean(evt: SelectOption, col: string) {
    this.filterData(evt.value, col, '')
  }

  /**
   * ON CHANGE DATA
   * @param evt 
   * @param col 
   */
  onChangeData(evt: string, col: string) {
    // GBR 24/02/2026 - MQF-15
    let _value: string = evt;
    if (this.inputFilterTimeoutId != undefined) clearTimeout(this.inputFilterTimeoutId);

    this.inputFilterTimeoutId = setTimeout(() => {
      if (this.paginable) this.pageIndex = 1; // applying new filters => move back to page 1 

      // Filter data
      if (!this.activeFilters) this.activeFilters = new Array();
      let _i: number = this.activeFilters.findIndex(x => x.columun!.toLowerCase() == col.toLowerCase());
      if (_value == '') {
        this.activeFilters = this.activeFilters.filter(x => x.columun!.toLowerCase() != col.toLowerCase());
        this.onActiveFiltersUpdate.emit(this.activeFilters);
        this.callOData();
        return;
      }

      let _temp: string[] = new Array();
      _temp = _value.split("|");
      if (_i == -1 && _temp[0] == 'ltgt') {
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = col;
        _item.dateDirection = 'gt';
        _item.isDefaultView = false;
        _item.operator = "date";
        _item.value = _temp[1];
        this.activeFilters.push(_item);

        _item = new ActiveFilter();
        _item.columun = col;
        _item.dateDirection = 'lt';
        _item.isDefaultView = false;
        _item.operator = "date";
        _item.value = _temp[2];
        this.activeFilters.push(_item);
      }

      if (_i != -1 && _temp[0] == 'ltgt') {
        this.activeFilters = this.activeFilters.filter(x => x.columun!.toLowerCase() != col.toLowerCase()); // Tolgo tutto e poi riaggiungo
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = col;
        _item.dateDirection = 'gt';
        _item.isDefaultView = false;
        _item.operator = "date-gt";
        _item.value = _temp[1];
        this.activeFilters.push(_item);

        _item = new ActiveFilter();
        _item.columun = col;
        _item.dateDirection = 'lt';
        _item.isDefaultView = false;
        _item.operator = "date-lt";
        _item.value = _temp[2];
        this.activeFilters.push(_item);
      }

      if (_i == -1 && (_temp[0] == 'lt' || _temp[0] == 'eq' || _temp[0] == 'gt')) {
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = col;
        _item.dateDirection = _temp[0];
        _item.isDefaultView = false;
        _item.operator = "date";
        _item.value = _temp[1];
        this.activeFilters.push(_item);
      }

      if (_i != -1 && (_temp[0] == 'lt' || _temp[0] == 'eq' || _temp[0] == 'gt')) {
        this.activeFilters[_i].dateDirection = _temp[0];
        this.activeFilters[_i].value = _temp[1];
      }

      this.onActiveFiltersUpdate.emit(this.activeFilters);
      this.callOData();
    }, 500);
    /* if (evt == '') {
      this.filterData('', col, '');
    } else {
      this.filterData(evt.split("|")[0], col, evt.split("|")[1]);
    } */
  }

  /**
   * ON CHANGE INPUT
   * @param evt 
   * @param col 
   */
  /*   onInputChange(evt: any, col: string) {
      this.filterData(evt, col, '')
    } */
  onInputChange(evt: any, col: string, colType: string, initialFilter: boolean = false) {
    // GBR 24/02/2026 - MQF-15
    let _value: string = evt;
    if (colType == 'number' && (_value.endsWith('.') == true || _value.endsWith(',') == true)) return;
    if (this.inputFilterTimeoutId != undefined && !initialFilter) clearTimeout(this.inputFilterTimeoutId);

    if (initialFilter) {
      this.filterData(evt, col, '', true);
    }
    else {
      this.inputFilterTimeoutId = setTimeout(() => {
        if (this.paginable) this.pageIndex = 1; // applying new filters => move back to page 1 

        this.filterData(evt, col, '', false);
      }, 500);
    }

  }

  onInputChangeNumericRange(evt: any, col: string, colType: string) {
    // GBR 24/02/2026 - MQF-15
    let _value: string = evt;
    if (this.inputFilterTimeoutId != undefined) clearTimeout(this.inputFilterTimeoutId);

    this.inputFilterTimeoutId = setTimeout(() => {
      if (this.paginable) this.pageIndex = 1; // applying new filters => move back to page 1 

      // Filter data
      if (!this.activeFilters) this.activeFilters = new Array();
      let _i: number = this.activeFilters.findIndex(x => x.columun!.toLowerCase().indexOf(col.toLowerCase()) != -1);
      const removeColumnFilters = () => {
        if (_i == -1) return;
        const columnToRemove = this.activeFilters[_i].columun!.toLowerCase();
        this.activeFilters = this.activeFilters.filter(x => x.columun!.toLowerCase() != columnToRemove);
        this.onActiveFiltersUpdate.emit(this.activeFilters);
        this.callOData();
      };

      if (_value == '') {
        removeColumnFilters();
        return;
      }

      let _temp: string[] = new Array();
      _temp = _value.split("|");
      const partValue = (idx: number): string => (_temp[idx] ?? '').toString().trim();
      const parseNumber = (value: string): number => parseFloat(value.replace(',', '.'));
      const hasNumber = (value: string): boolean => value !== '' && !isNaN(parseNumber(value));
      const operator = partValue(0);
      const value1 = partValue(1);
      const value2 = partValue(2);
      const value3 = partValue(3);

      let validPayload = false;
      if (operator == 'ltgt') {
        const hasUom = _temp.length < 4 || value3 != '';
        validPayload = hasNumber(value1) && hasNumber(value2) && (parseNumber(value1) < parseNumber(value2)) && hasUom;
      } else if (operator == 'lt' || operator == 'eq' || operator == 'gt') {
        const hasUom = _temp.length < 3 || value2 != '';
        validPayload = hasNumber(value1) && hasUom;
      }

      if (!validPayload) {
        removeColumnFilters();
        return;
      }

      let uom: string = "";
      if (col.indexOf('InsideDiameter') != -1) uom = 'IdUom';
      if (col.indexOf('OutsideDiameter') != -1) uom = 'OdUom';
      if (col.indexOf('Length') != -1) uom = 'LengthUom';
      if (col.indexOf('TotalBookedWeight') != -1 || col.indexOf('BookedTotalWeight') != -1) {
        const hasBookedWeightUom = this.columnsGOD?.some(x => x.name == 'BookedTotalWeightUom');
        uom = hasBookedWeightUom ? 'BookedTotalWeightUom' : 'TotalWeightUom';
      }
      else if (col.indexOf('TotalWeight') != -1) uom = 'TotalWeightUom';
      if (col.indexOf('TotalLength') != -1) uom = 'TotalLengthUom';
      if (col.indexOf('WallThickness') != -1) uom = 'WtUom';

      if (_i == -1 && _temp[0] == 'ltgt') {
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = _temp.length == 2 ? col : "convert_from_uom_to_uom(" + col + "," + uom + ", '" + _temp[3] + "')";
        _item.dateDirection = 'gt';
        _item.isDefaultView = false;
        _item.operator = "num";
        _item.value = _temp[1];
        this.activeFilters.push(_item);

        _item = new ActiveFilter();
        _item.columun = _temp.length == 2 ? col : "convert_from_uom_to_uom(" + col + "," + uom + ", '" + _temp[3] + "')";
        _item.dateDirection = 'lt';
        _item.isDefaultView = false;
        _item.operator = "num";
        _item.value = _temp[2];
        this.activeFilters.push(_item);
      }

      if (_i != -1 && _temp[0] == 'ltgt') {
        this.activeFilters = this.activeFilters.filter(x => x.columun!.toLowerCase() != this.activeFilters[_i].columun!.toLowerCase()); // Tolgo tutto e poi riaggiungo
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = _temp.length == 2 ? col : "convert_from_uom_to_uom(" + col + "," + uom + ", '" + _temp[3] + "')";
        _item.dateDirection = 'gt';
        _item.isDefaultView = false;
        _item.operator = "num";
        _item.value = _temp[1];
        this.activeFilters.push(_item);

        _item = new ActiveFilter();
        _item.columun = _temp.length == 2 ? col : "convert_from_uom_to_uom(" + col + "," + uom + ", '" + _temp[3] + "')";
        _item.dateDirection = 'lt';
        _item.isDefaultView = false;
        _item.operator = "num";
        _item.value = _temp[2];
        this.activeFilters.push(_item);
      }

      if (_i == -1 && (_temp[0] == 'lt' || _temp[0] == 'eq' || _temp[0] == 'gt')) {
        let _item: ActiveFilter = new ActiveFilter();
        _item.columun = _temp.length == 2 ? col : "convert_from_uom_to_uom(" + col + "," + uom + ", '" + _temp[2] + "')";
        _item.dateDirection = _temp[0];
        _item.isDefaultView = false;
        _item.operator = "num";
        _item.value = _temp[1];
        this.activeFilters.push(_item);
      }

      if (_i != -1 && (_temp[0] == 'lt' || _temp[0] == 'eq' || _temp[0] == 'gt')) {
        this.activeFilters[_i].columun = _temp.length == 2 ? col : "convert_from_uom_to_uom(" + col + "," + uom + ", '" + _temp[2] + "')";
        this.activeFilters[_i].dateDirection = _temp[0];
        this.activeFilters[_i].value = _temp[1];
      }

      this.onActiveFiltersUpdate.emit(this.activeFilters);
      this.callOData();
    }, 500);
  }

  /**
   * GRID SETTINGS EVENTS
   * @param evt 
   */
  onCloseSettings(evt: any) {
    this.showSettingsDialog = false;
    this.gridConfiguration = new GridConfiguration();
    this.gridConfiguration = JSON.parse(evt);
    this.onCloseDialogSettings.emit('');
  }

  onApplySettings(gridConfiguration: GridConfiguration) {
    this.teiasoftLoader.start();
    this.gridConfiguration = new GridConfiguration()
    this.gridConfiguration = gridConfiguration;
    this.columnsGOD = new Array();
    this.columnsGOD = gridConfiguration.gridColumns!;
    this.setFilters();
    //this.setDimensionsGOD('applySettings');
    this.showSettingsDialog = false;
    this.onCloseDialogSettings.emit('');
    this.sortDirection = '';
    this.sortedCol = '';

    // If Something is chanaged I update the configuration
    if (this.oldGridConfiguration != JSON.stringify(this.gridConfiguration)) this.onUpdateConfiguration.emit(this.gridConfiguration);
    // If GridSorting is chanages reefresh the grid
    if (this.oldGridSorting != JSON.stringify(this.gridConfiguration.gridSortings!)) {
      this.pageIndex = 1; // go back to page 1
      this.callOData();
    } else {
      setTimeout(() => this.setDimensionsGOD('applySettings'), 250);
    }
    this.teiasoftLoader.stop();

  }

  onColumnWidthUpdate(gridConfiguration: GridConfiguration) {
    // this.gridConfiguration = new GridConfiguration()
    // this.gridConfiguration = gridConfiguration;
    // this.columnsGOD = new Array();
    // this.columnsGOD = gridConfiguration.gridColumns!;
    if (this.columnsGOD?.length && gridConfiguration.gridColumns?.length) {
      for (const gc of gridConfiguration.gridColumns) {
        const idx = this.columnsGOD.findIndex(col => col.name === gc.name);
        if (idx !== -1 && gc.width != null) {
          this.columnsGOD[idx].width = gc.width;
        }
      }
    }
    // this.containerWidth = $('.tgodata-header').width()
    this.onUpdateConfiguration.emit(this.gridConfiguration);
  }

  /************************************** NEW FILTER MANAGEMENT ******************************************************/
  private resetFilterValuesState(): void {
    this.filterValuesLoaded = false;
    this.filterValuesLoading = false;
    this.filters = new Array();
    this.oDataFilterMaps = new Array();
    this.defaultEnquiryBookUomFiltersByColumn = {};
  }

  private ensureODataFilterValuesLoaded(): void {
    if (!this.filterable  || this.filterValuesLoading || !this.oDataUrl) return;

    switch (this.oDataUrl) {
      case 'Enquiries':
        this.getEnquiryBookFiltersValues();
        break;
      case 'Logs':
        this.getLogsFiltersValues();
        break;
      case 'History':
        this.getHistoryFiltersValues();
        break;
      case 'activeItdcrs':
      case 'toComeItdcrs':
      case 'latestSentItdcrs':
        this.getCurrentItdcrsFiltersValues();
        break;
      case 'itdcrsHistory':
        this.getHistoryItdcrsFiltersValues();
        break;
    }
  }

  private markFilterValuesLoading(): void {
    this.filterValuesLoading = true;
  }

  private markFilterValuesLoaded(): void {
    this.filterValuesLoading = false;
    this.filterValuesLoaded = true;
  }

  private markFilterValuesLoadFailed(): void {
    this.filterValuesLoading = false;
  }

  private normalizeEnquiryBookFilterValues(filters: any): any {
    if (!filters || typeof filters !== 'object') return filters;

    const filtersToNormalize = new Set(['iduoms', 'oduoms', 'wtuoms', 'totalweightuoms']);
    const normalizedFilters: any = { ...filters };

    for (const key of Object.keys(normalizedFilters)) {
      if (!filtersToNormalize.has(key.toLowerCase())) continue;

      const rawValues = normalizedFilters[key];
      if (!Array.isArray(rawValues)) continue;

      const preferredValues: string[] = new Array();
      const otherValues: string[] = new Array();
      const seenValues = new Set<string>();

      for (const rawValue of rawValues) {
        const isObjectValue = rawValue != undefined && rawValue != null && typeof rawValue === 'object' && !Array.isArray(rawValue);
        const parsedValue = isObjectValue ? rawValue['value'] : rawValue;
        const normalizedValue = (parsedValue ?? '').toString().trim();
        if (normalizedValue == '') continue;

        const normalizedKey = normalizedValue.toLowerCase();
        if (seenValues.has(normalizedKey)) continue;
        seenValues.add(normalizedKey);

        if (isObjectValue && rawValue['isDefault'] === true) preferredValues.push(normalizedValue);
        else otherValues.push(normalizedValue);
      }

      normalizedFilters[key] = [...preferredValues, ...otherValues];
    }

    return normalizedFilters;
  }

  private extractDefaultEnquiryBookFilterValues(filters: any): { [filterName: string]: string[] } {
    const defaultsByFilterName: { [filterName: string]: string[] } = {};
    if (!filters || typeof filters !== 'object') return defaultsByFilterName;

    const filtersToNormalize = new Set(['iduoms', 'oduoms', 'wtuoms', 'totalweightuoms']);
    for (const key of Object.keys(filters)) {
      if (!filtersToNormalize.has(key.toLowerCase())) continue;

      const rawValues = filters[key];
      if (!Array.isArray(rawValues)) continue;

      const defaults: string[] = new Array();
      const seenDefaults = new Set<string>();
      for (const rawValue of rawValues) {
        const isObjectValue = rawValue != undefined && rawValue != null && typeof rawValue === 'object' && !Array.isArray(rawValue);
        if (!isObjectValue || rawValue['isDefault'] !== true) continue;

        const normalizedValue = (rawValue['value'] ?? '').toString().trim();
        if (normalizedValue == '') continue;

        const normalizedKey = normalizedValue.toLowerCase();
        if (seenDefaults.has(normalizedKey)) continue;
        seenDefaults.add(normalizedKey);
        defaults.push(normalizedValue);
      }

      if (defaults.length > 0) {
        defaultsByFilterName[key] = defaults;
      }
    }

    return defaultsByFilterName;
  }

  private mapDefaultEnquiryBookUomFiltersByColumn(defaultValuesByFilterName?: { [filterName: string]: string[] }): void {
    this.defaultEnquiryBookUomFiltersByColumn = {};

    if (!defaultValuesByFilterName || Object.keys(defaultValuesByFilterName).length == 0) return;
    if (!this.oDataFilterMaps || this.oDataFilterMaps.length == 0) return;

    const managedColumns = new Set<string>(['oduom', 'iduom', 'wtuom', 'totalweightuom']);
    for (const filterName of Object.keys(defaultValuesByFilterName)) {
      const map = this.oDataFilterMaps.find(x => x.filterName?.toLowerCase() == filterName.toLowerCase());
      if (!map?.columnName) continue;
      if (!managedColumns.has(map.columnName.toLowerCase())) continue;

      const defaultValues = (defaultValuesByFilterName[filterName] || [])
        .map(v => (v ?? '').toString().trim())
        .filter(v => v != '');
      if (defaultValues.length == 0) continue;

      this.defaultEnquiryBookUomFiltersByColumn[map.columnName] = [...defaultValues];
    }
  }

  getSelectedSpecialFilterValues(colName: string): string[] {
    const filter = (this.activeFilters || []).find(x =>
      x.columun?.toLowerCase() == colName.toLowerCase() && x.operator == 'in'
    );

    if (filter && Array.isArray(filter.value)) return filter.value as string[];

    const uomColumns = new Set<string>(['oduom', 'iduom', 'wtuom', 'totalweightuom', 'bookedtotalweightuom']);
    if (!uomColumns.has(colName.toLowerCase())) return [];

    const extractedUoms = new Set<string>();
    const regex = /convert_from_uom_to_uom\(\s*[^,]+,\s*([A-Za-z0-9_]+)\s*,\s*'([^']+)'\s*\)/i;

    for (const activeFilter of (this.activeFilters || [])) {
      if (activeFilter.operator != 'num' || !activeFilter.columun) continue;

      const match = regex.exec(activeFilter.columun);
      if (!match || match.length < 3) continue;

      const sourceUomColumn = (match[1] ?? '').toString().trim();
      const targetUom = (match[2] ?? '').toString().trim();
      if (sourceUomColumn.toLowerCase() != colName.toLowerCase()) continue;
      if (targetUom == '') continue;

      extractedUoms.add(targetUom);
    }

    return [...extractedUoms];
  }

  getEnquiryBookFiltersValues() {
    this.markFilterValuesLoading();
    this.subscriptions.add(this.beservice.getEnquiryBookFiltersValues(this.filterScope).subscribe(res => {
      this.filters = new Array();
      this.filters = this.normalizeEnquiryBookFilterValues(res);
      const defaultValuesByFilterName = this.extractDefaultEnquiryBookFilterValues(res);
      this.getODataFiltersMapping("enquiries", defaultValuesByFilterName);
    }, () => this.markFilterValuesLoadFailed())
    );
  }

  getLogsFiltersValues() {
    this.markFilterValuesLoading();
    this.subscriptions.add(this.beservice.getLogsFiltersValues().subscribe(res => {
      this.filters = new Array();
      this.filters = res;
      this.getODataFiltersMapping("logs");
    }, () => this.markFilterValuesLoadFailed())
    );
  }

  getHistoryFiltersValues() {
    this.markFilterValuesLoading();
    this.subscriptions.add(this.beservice.getHistoryFiltersValues().subscribe(res => {
      this.filters = new Array();
      this.filters = res;
      this.getODataFiltersMapping("history");
    }, () => this.markFilterValuesLoadFailed())
    );
  }

  getCurrentItdcrsFiltersValues() {
    this.markFilterValuesLoading();
    this.subscriptions.add(this.beservice.getCurrentItdcrsFiltersValues().subscribe(res => {
      this.filters = new Array();
      this.filters = res;
      this.getODataFiltersMapping("currentItdcr");
    }, () => this.markFilterValuesLoadFailed())
    );
  }

  getHistoryItdcrsFiltersValues() {
    this.markFilterValuesLoading();
    this.subscriptions.add(this.beservice.getHistoryItdcrsFiltersValues().subscribe(res => {
      this.filters = new Array();
      this.filters = res;
      this.getODataFiltersMapping("currentItdcr");
    }, () => this.markFilterValuesLoadFailed())
    );
  }

  getODataFiltersMapping(gridName: string, defaultValuesByFilterName?: { [filterName: string]: string[] }) {
    this.subscriptions.add(this.oDataService.getODataFiltersMapping().subscribe(res => {
      this.oDataFilterMaps = new Array();
      this.oDataFilterMaps = res.filter(x => x.grid == gridName)[0].filters!;
      if (gridName == "enquiries") {
        this.mapDefaultEnquiryBookUomFiltersByColumn(defaultValuesByFilterName);
        this.refreshNumericFiltersUomOptions();
      } else {
        this.defaultEnquiryBookUomFiltersByColumn = {};
      }
      this.setupInitialFilters(); // evaluate initial filters 
      this.markFilterValuesLoaded();

    }, () => this.markFilterValuesLoadFailed()));

  }

  private refreshNumericFiltersUomOptions(): void {
    if (!this.gridFilters || this.gridFilters.length == 0) return;

    for (const filter of this.gridFilters) {
      if (filter.filterType != 'number' || !filter.column) continue;
      filter.optionsList = this.getUoms(filter.column);
    }
  }

  isSpecialFilter(colName: string): boolean {
    if (this.oDataFilterMaps.findIndex(x => x.columnName == colName) != -1)
      return true;
    else
      return false;
    /*  for (const prop in this.filters){
       if (prop.toLowerCase() == colName.toLowerCase() + "s")
         return true;
     } 
     return false;*/
  }

  onSelectedFilterOptions(evt: any[], col: string, colType: string, applyInitialFilter: boolean = false) {
    // GBR 24/02/2026 - MQF-15
    //let _value: string = evt;
    //if (colType == 'number' && ( _value.endsWith('.') == true || _value.endsWith(',') == true)) return;
    if (this.inputFilterTimeoutId != undefined && !applyInitialFilter) clearTimeout(this.inputFilterTimeoutId);

    if (applyInitialFilter) {
      this.filterDataSpecial(evt, col, true);
    }
    else {
      // no debounce here: this event comes from an explicit OK click, apply immediately
      if (this.paginable) this.pageIndex = 1; // applying new filters => move back to page 1
      this.filterDataSpecial(evt, col, false);
    }

  }

  filterDataSpecial(values: any[], col: string, skipODataCall: boolean = false) {
    if (!this.activeFilters) this.activeFilters = new Array();
    //if (values.length == 0) this.activeFilters = new Array();
    let _i: number = this.activeFilters.findIndex(x => x.columun!.toLowerCase() == col.toLowerCase());

    // First tme for this filter
    if (_i == -1 && values.length > 0) {
      let _item: ActiveFilter = new ActiveFilter();
      _item.columun = col;
      _item.dateDirection = '';
      _item.isDefaultView = false;
      _item.operator = 'in';
      _item.value = values;
      this.activeFilters.push(_item);
    }

    // Filter already present e new values
    if (_i != -1 && values.length > 0) {
      this.activeFilters[_i].value = values;
    }

    // Filters already prente but no values (reset)
    if (_i != -1 && values.length == 0) {
      this.activeFilters = this.activeFilters.filter(x => x.columun!.toLowerCase() != col.toLowerCase());
    }

    this.onActiveFiltersUpdate.emit(this.activeFilters);
    if (!skipODataCall)
      this.callOData();
  }

  getUoms(col: string): SelectOption[] {
    let _list: SelectOption[] = new Array();
    let uom: string = "";
    if (col == 'InsideDiameter') uom = 'idUoms';
    if (col == 'OutsideDiameter') uom = 'odUoms';
    if (col == 'Length') uom = 'LengthUoms';
    if (col == 'TotalWeight' || col == 'TotalBookedWeight' || col == 'BookedTotalWeight') uom = 'TotalWeightUoms';
    if (col == 'TotalLength' || col == 'TotalBookedLength' || col == 'BookedTotalLength') uom = 'LengthUoms';
    if (col == 'WallThickness') uom = 'wtUoms';

    let _item: SelectOption = new SelectOption();
    _item.text = '';
    _item.value = '';
    _list.push(_item);

    const getDefaultUomForNumericColumn = (columnName: string): string => {
      const uomColumnByNumericColumn: { [columnName: string]: string } = {
        OutsideDiameter: 'OdUom',
        InsideDiameter: 'IdUom',
        WallThickness: 'WtUom',
        TotalWeight: 'TotalWeightUom',
        TotalBookedWeight: 'TotalWeightUom',
        BookedTotalWeight: 'TotalWeightUom',
        TotalLength: 'TotalLengthUom',
        TotalBookedLength: 'TotalLengthUom',
        BookedTotalLength: 'TotalLengthUom'
      };

      const uomColumn = uomColumnByNumericColumn[columnName];
      if (!uomColumn) return '';

      const defaults = this.defaultEnquiryBookUomFiltersByColumn[uomColumn];
      if (!defaults || defaults.length == 0) return '';
      return defaults[0];
    };

    const defaultUom = getDefaultUomForNumericColumn(col);
    const addedUoms = new Set<string>();
    const collectedUoms: string[] = new Array();
    const appendUom = (uomCode?: string) => {
      const normalizedUom = (uomCode ?? '').toString().trim();
      if (normalizedUom == '') return;

      const dedupeKey = normalizedUom.toLowerCase();
      if (addedUoms.has(dedupeKey)) return;

      collectedUoms.push(normalizedUom);
      addedUoms.add(dedupeKey);
    };

    for (const prop in this.headerParametersValues) {
      if (prop.toLowerCase().toString() == uom.toLowerCase()) {
        let _uoms: UomsType = new UomsType();
        _uoms = this.headerParametersValues[prop as keyof HeaderParametersValues] as UomsType;
        _uoms.metricUoms?.forEach(mu => appendUom(mu?.uomCode));
        _uoms.imperialUoms?.forEach(iu => appendUom(iu?.uomCode));
        break;
      }
    }

    if (defaultUom != '') {
      const defaultKey = defaultUom.toLowerCase();
      const currentIdx = collectedUoms.findIndex(x => x.toLowerCase() == defaultKey);
      if (currentIdx == -1) {
        collectedUoms.unshift(defaultUom);
      } else if (currentIdx > 0) {
        const def = collectedUoms.splice(currentIdx, 1)[0];
        collectedUoms.unshift(def);
      }
    }

    for (const uomCode of collectedUoms) {
      let option: SelectOption = new SelectOption();
      option.text = uomCode;
      option.value = uomCode;
      option.isDefault = defaultUom != '' && uomCode.toLowerCase() == defaultUom.toLowerCase();
      _list.push(option);
    }

    return _list;
  }

  /************************************** UTILS **********************************************************************/
  isEven(n: number): boolean {
    return n % 2 == 0;
  }

  cellClick(cell: ClickedCell) {
    this.onCellClick.emit(cell);
  }

  onCellClickOdatGrid(row: any, colName: string) {
    if ((colName == 'HasCustomerSpecialRequirements' && row["HasCustomerSpecialRequirements"]) ||
      (colName == 'EnquiryHasCustomerSpecialRequirements' && row["EnquiryHasCustomerSpecialRequirements"])) {
      let _obj: ClickedCell = new ClickedCell();
      _obj.colName = colName;
      _obj.row = row;
      this.onCellClick.emit(_obj);
    }

    if (colName != 'NumberOfAttachments') return;
    if (row["NumberOfAttachments"] == null) return;

    let _obj: ClickedCell = new ClickedCell();
    _obj.colName = colName;
    _obj.row = row;
    this.onCellClick.emit(_obj);
  }

  onExpandedGridContextMenuClick(evt: any, parentRow: any) {
    this.customIconContextMenuClick.emit({ ...evt, parentRow });
  }

  selectedUomChange(evt: string, col: string) {
    /*  let _i: number = -1;
     _i = this.activeFilters.findIndex(x => x.columun!.toLowerCase().indexOf(col.toLowerCase()) != -1);
     if (_i != -1){
       this.activeFilters[_i].columun = "convert_from_uom_to_uom(" + col + ", OdUom, '" + evt + "')";
       this.filterData('',col,'');
       //this.selectedUom = evt.value;
     } */

  }

  onColumnSizeCalculationEnd() {
  }

  getStickyLeftPosition(index: number): number | undefined {
    let visibleFrozenColumns = this.gridConfiguration!.gridColumns!
      .filter(gc => gc.visible && gc.position! <= this.gridConfiguration.frozenColumns);

    // Find the correct visible index in the filtered frozen columns list
    let visibleIndex = visibleFrozenColumns.findIndex(col => col.name === this.columnsGOD[index].name);

    if (visibleIndex !== -1) {
      let leftPosition = this.stickyContainerWidth; // Start with initial offset

      // Sum up all previous *visible frozen* columns' widths
      for (let i = 0; i < visibleIndex; i++) {
        leftPosition += visibleFrozenColumns[i]?.width ?? 0;
      }

      return leftPosition;
    }

    return undefined;
  }

  isSticky(index: number): boolean {
    return this.columnsGOD[index].visible! && index < this.gridConfiguration.frozenColumns;
  }

  getExpandedTableDescription(): string {
    return this.dataSetRow.length + ' ' + this.translateService.instant('enquiryBook.item(s)')
  }

  isColumnClickable(col: GridColumn, row: any): boolean {
      if (col.name! == 'NumberOfAttachments' && row['NumberOfAttachments'] != null)
        return true;
      if (col.name! == 'HasCustomerSpecialRequirements' && row['HasCustomerSpecialRequirements'])
        return true;
      if (col.name! == 'EnquiryHasCustomerSpecialRequirements' && row['EnquiryHasCustomerSpecialRequirements'])
        return true;
      return false;
    }

}
